import { CardSvg } from '@/play/cardSvg'

/** Home card art for Ghost letters: a pale A being drawn on paper, two eyes watching the pen. */
export function GhostLettersCardArt() {
  return (
    <CardSvg bg="#e9e1d2">
      <path d="M40 176 L 86 70 H 248 L 286 176 Z" fill="#f7f2e6" />
      <path d="M163 82 L 128 160 M163 82 L 184 128" fill="none" stroke="#8fb8ff" strokeWidth="9" strokeLinecap="round" opacity="0.85" />
      <circle cx="184" cy="128" r="6" fill="#5b8ef0" />
      <circle cx="146" cy="186" r="11" fill="#fff" stroke="#1d2b36" strokeWidth="2.4" />
      <circle cx="174" cy="186" r="11" fill="#fff" stroke="#1d2b36" strokeWidth="2.4" />
      <circle cx="149" cy="182" r="4.5" fill="#1d2b36" />
      <circle cx="177" cy="182" r="4.5" fill="#1d2b36" />
    </CardSvg>
  )
}
